import getTranslation from 'bdata-sns-shared/utils/getTranslation';

const BREAK = ' | ';

// Craft the postseason game info.
// Check first for shortName, game number, and result. Display if given
// Hide game number if tiebreaker or wildcard
export const getPostseasonGameInfo = (options) => {
    const { dictionary, shortName, gameNumber, result, hideGameNum, ifNecessary, gameType, leagueID, winningTeam, isOver, isTied, wins, losses } = options;
    // This boolean will keep track of if we need to use a break or not.
    let firstValueSet = false;

    // Set strings to use in returned string
    let shortNameString = '';
    let gameString = '';
    let gameStringAbbrev = '';
    let ifNecessaryString = '';
    let ifNecessaryStringAbbrev = '';
    let shortNameStringAbbrev = '';

    if (typeof shortName !== 'undefined') {
        firstValueSet = true;
        shortNameString = getTranslation(dictionary, `label_gameType_${gameType}_${leagueID}`, '') || getTranslation(dictionary, `label_gameType_${gameType}`, '') || getTranslation(dictionary, shortName, shortName);
    }
    if (typeof gameType !== 'undefined') {
        firstValueSet = true;
        shortNameStringAbbrev = getTranslation(dictionary, `label_postseason_abbrev_${gameType}` + (leagueID ? `_${leagueID}` : ''), shortName);
    }

    // Hiding game num if tiebreaker or wildcard
    if (gameNumber && !hideGameNum) {
        gameString = `${firstValueSet ? BREAK : ''}${getTranslation(dictionary, 'game', 'Game')} ${gameNumber}`;
        gameStringAbbrev = `${firstValueSet ? ' ' : ''}${getTranslation(dictionary, 'label_game_abbrev', 'G')}${gameNumber}`;
    }

    if (ifNecessary === 'Y') {
        ifNecessaryString = `(${getTranslation(dictionary, 'label_if_necessary', 'if necessary')})`;
        ifNecessaryStringAbbrev = '*';
    }

    const ariaSeries = getTranslation(dictionary, 'reader_postseason_series', `${shortNameString} game ${gameNumber}`, { seriesString: shortNameString, gameNumber });

    const ariaResult = !isTied
        ? getTranslation(dictionary, 'reader_postseason_series_result', `${winningTeam?.name} ${isOver ? 'wins' : 'leads'} the series, ${wins} game${wins !== 1 ? 's' : ','} to ${losses}.`, { winningTeam: winningTeam?.name, winsOrLeads: isOver ? 'wins' : 'leads', wins, winsPlural: wins !== 1 ? 's' : ',', losses })
        : getTranslation(dictionary, 'reader_postseason_series_tied', `The series is tied ${wins} to ${losses}`, { wins, losses });

    return {
        seriesInfo: `${shortNameString}${gameString}`,
        result,
        ariaResult,
        ariaSeries,
        gameText: gameString,
        ifNecessaryText: ifNecessaryString,
        seriesInfoAbbrev: `${shortNameStringAbbrev}${gameStringAbbrev}${ifNecessaryStringAbbrev}`
    };
};
